import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=18c1fbd0&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=18c1fbd0&scoped=true&rel=stylesheet%2Fscss&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c1fbd0",
  null
  
)

export default component.exports